/**
 * Automatic-renewal disclosure shown right under the plan cards (California
 * Automatic Renewal Law: clear terms next to the button that starts the
 * subscription). Stripe Checkout repeats the same terms above its pay button
 * (billing/index.js custom_text). Plus the responsible-gambling helpline.
 */
import React from 'react';
import { Text, StyleSheet, Platform, View } from 'react-native';

export const AUTO_RENEW_TERMS = 'Paid plans renew automatically every month or year, at the regular price shown (after any promotional discount ends), until you cancel. You can cancel anytime on this page (Manage billing); you keep access until the end of the period you paid for, and partial periods are not refunded. By choosing a paid plan you agree to these terms and to our';

export default function CheckoutTerms({ color = 'rgba(255,255,255,0.62)', linkColor = '#93C5FD', navigateTo, style }) {
  const link = (label, path, screen) => (
    <Text
      style={[styles.link, { color: linkColor }]}
      accessibilityRole="link"
      onPress={(e) => {
        if (!navigateTo) return;
        e?.preventDefault?.(); // in-app navigation instead of a full page load
        navigateTo(screen);
      }}
      {...(Platform.OS === 'web' ? { href: path } : {})}
    >
      {label}
    </Text>
  );
  return (
    <View style={[styles.wrap, style]} testID="checkout-terms">
      <Text style={[styles.text, { color }]}>
        {AUTO_RENEW_TERMS} {link('Terms of Service', '/terms', 'Terms')} and {link('Privacy Policy', '/privacy', 'Privacy')}. During the free beta nothing is charged.
      </Text>
      <Text style={[styles.text, styles.help, { color }]}>
        21+ only. Gambling problem? Call 1-800-GAMBLER (1-800-426-2537) or 1-800-522-4700.
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  wrap: { alignSelf: 'center', width: '100%', maxWidth: 760, marginTop: 20, paddingHorizontal: 16, gap: 6 },
  text: { fontSize: 13, lineHeight: 19, textAlign: 'center' },
  help: { fontSize: 12, opacity: 0.85 },
  link: { textDecorationLine: 'underline', ...(Platform.OS === 'web' ? { cursor: 'pointer' } : {}) },
});
